export default {
    DOWNPAYMENT: "DOWNPAYMENT",
    LOAN_PAYMENT: "LOANPAYMENT"
}
